import { getTenantPostLoginConfig } from 'tenant/teanantPostLoginConfig';

const initialState = {
  ...getTenantPostLoginConfig(),
};

const initialStateForTest = {};

export default initialState;
export { initialStateForTest };
